import React, { useState } from 'react';
import styles from './onboarding.module.css';
import CardCarousel from './CardCarousel';
import pleasantness from '../../images/onboarding/pleasantness.png';
import peakvalley from '../../images/onboarding/peakvalley.png';
import uplifters from '../../images/onboarding/uplifters.png';

// FadeInImage component for fade-in effect on load
function FadeInImage({ src, alt, ...props }) {
    const [loaded, setLoaded] = useState(false);
    return (
        <img
            src={src}
            alt={alt}
            onLoad={() => setLoaded(true)}
            className={styles.cardContentImg}
            style={{
                opacity: loaded ? 1 : 0,
                transition: 'opacity 0.5s ease',
            }}
            {...props}
        />
    );
}

const myCards = [
    { id: 3, content: <FadeInImage src={uplifters} alt="What uplifted you" /> },
    { id: 1, content: <FadeInImage src={pleasantness} alt="Week pleasantness" /> },
    { id: 2, content: <FadeInImage src={peakvalley} alt="Peak and valley" /> },
];

function InsightsPreview() {
    return (
        <>
            <div></div> {/* Empty div for centering */}
            <div className={styles.flexDiv} style={{ margin: "0 0.2rem", paddingTop: '4rem', paddingBottom: '1rem', gap: '1rem' }}>
                <h1 className={styles.onboardingGreeting}>
                    Your signals, summed up.
                </h1>
                <CardCarousel cards={myCards} />
                <p className={styles.para} style={{ fontWeight: 500 }}>
                    The more you flow, the clearer the picture.
                </p>
            </div>
        </>
    )
}

export default InsightsPreview;